import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeContent";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href: string) => () => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between gap-3 px-4 md:px-6">
        {/* 站点名 */}
        <a
          href="#top"
          onClick={go("#top")}
          className="flex shrink-0 items-center gap-2.5"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-water-flash-fill text-base"></i>
          </span>
          <span className="whitespace-nowrap font-heading text-lg font-black tracking-tight text-foreground-950">
            吃瓜网址
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={go(l.href)}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#about"
            onClick={go("#about")}
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-road-map-line mr-1.5 text-base leading-none"></i>
            认准新入口
          </a>

          {/* 移动端菜单按钮 */}
          <button
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-200 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {/* 移动端面板 */}
      <div
        className={`md:hidden overflow-hidden border-t border-secondary-100 transition-all duration-300 ${
          open ? "max-h-96 bg-background-50/95" : "max-h-0 border-t-0"
        }`}
      >
        <nav className="mx-auto flex max-w-6xl flex-col gap-1 px-4 py-3">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={go(l.href)}
              className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#about"
            onClick={go("#about")}
            className="mt-1 inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
          >
            <i className="ri-road-map-line mr-1.5 text-base leading-none"></i>
            认准新入口
          </a>
        </nav>
      </div>
    </header>
  );
}